// Booking / Availability related configuration
// These values can be overridden via Vite environment variables.
// Rationale for defaults:
// - QUERY LIMIT (500): balances UI responsiveness with reducing pagination churn.
//   Typical monthly booking volumes are << 500; raising much higher increases payload size and memory.
// - POLL INTERVAL (30000ms): balanced freshness (30s) vs. server load for typical operational needs.
//   Override via VITE_APP_BOOKINGS_POLL_INTERVAL_MS for environments needing faster (e.g. staging) or slower (e.g. high scale) updates.

const envLimit = Number(import.meta.env.VITE_APP_BOOKINGS_QUERY_LIMIT);
export const BOOKINGS_QUERY_LIMIT =
  Number.isFinite(envLimit) && envLimit > 0 ? envLimit : 500;

const envPoll = Number(import.meta.env.VITE_APP_BOOKINGS_POLL_INTERVAL_MS);
export const BOOKINGS_POLL_INTERVAL_MS =
  Number.isFinite(envPoll) && envPoll >= 5000 ? envPoll : 30000; // enforce a sane lower bound (5s) & default to 30s

export const bookingConfig = {
  QUERY_LIMIT: BOOKINGS_QUERY_LIMIT,
  POLL_INTERVAL_MS: BOOKINGS_POLL_INTERVAL_MS,
};
